// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading_container__2w2nV","small":"Loading_small__tuLzZ"};